import { shaderMaterial } from "@react-three/drei";
import { extend } from "@react-three/fiber";
import * as THREE from "three";

const LightColumnMaterial = shaderMaterial(
    {
        time: 0,
        color: new THREE.Color(0.7, 0.7, 1.0),
        glowColor: new THREE.Color(0.7, 0.7, 1.0),
        glowStrength: 1.5,
        glowRadius: 0.5,
        intensity: 3.0,
    },
  // Vertex Shader
  /*glsl*/ `
    varying vec2 vUv;
    varying vec3 vPosition;
    varying vec3 vNormal;
    
    void main() {
      vUv = uv;
      vPosition = position;
      vNormal = normalize(normalMatrix * normal);
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  // Fragment Shader
  /*glsl*/ `
    uniform float time;
    uniform vec3 color;
    uniform vec3 glowColor;
    uniform float glowStrength;
    uniform float glowRadius;
    uniform float intensity;
    
    varying vec2 vUv;
    varying vec3 vPosition;
    varying vec3 vNormal;
    
    void main() {
      // Effet de pulsation
      float pulse = sin(time * 2.0) * 0.5 + 0.5;
      
      // Effet de gradient vertical
      float gradient = vUv.y;
      
      // Effet de glow sur les bords
      float fresnel = pow(1.0 - abs(dot(vNormal, vec3(0.0, 0.0, 1.0))), glowRadius);
      
      // Couleur finale avec émissivité
      vec3 finalColor = mix(color, glowColor, fresnel * glowStrength);
      finalColor *= (1.0 + pulse * 0.2); // Ajoute la pulsation
      finalColor *= (0.8 + gradient * 0.4); // Ajoute le gradient
      finalColor *= intensity; // Utilisation de l'intensité globale
      
      // Ajout d'intensité pour l'effet émissif
      finalColor *= 2.0;
      
      gl_FragColor = vec4(finalColor, 1.0);
    }
  `
);

extend({ LightColumnMaterial });

export default LightColumnMaterial; 